'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('document-tree-editor', {
      url: '/admin/document-tree-editor',
      template: '<document-tree-editor></document-tree-editor>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/document-tree/document-tree-editor.routes.js